import SidebarNavigationItemContainer from './containers/SidebarNavigationItemContainer';

export default SidebarNavigationItemContainer;
